import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "mb-1 pa-1 content-header" };
const _hoisted_3 = { class: "text-right header-title-text" };
const _hoisted_4 = { class: "text-center contents-title-text" };
const _hoisted_5 = { class: "content-header-item mr-2" };
const _hoisted_6 = { class: "text-right mr-2 contents-title-text" };
const _hoisted_7 = { class: "book-number-info" };
const _hoisted_8 = { class: "text-right" };
const _hoisted_9 = { class: "mr-2 contents-sub-title-text" };
const _hoisted_10 = { class: "contents-title-text" };
const _hoisted_11 = { class: "text-right" };
const _hoisted_12 = { class: "mr-2 contents-sub-title-text" };
const _hoisted_13 = { class: "contents-title-text" };
const _hoisted_14 = { class: "content-header-item mr-2" };
const _hoisted_15 = { class: "text-right mr-2 contents-title-text" };
const _hoisted_16 = { class: "text-right contents-sub-title-text" };
const _hoisted_17 = { class: "d-flex mb-1" };
const _hoisted_18 = { class: "header-content" };
const _hoisted_19 = { class: "text-center" };
const _hoisted_20 = { class: "text-center" };
const _hoisted_21 = { class: "text-center" };
const _hoisted_22 = { class: "text-center" };
const _hoisted_23 = { class: "text-right" };
const _hoisted_24 = { class: "text-right" };
const _hoisted_25 = { class: "header-content memo" };
const _hoisted_26 = { class: "header-content memo" };
const _hoisted_27 = { class: "header-content memo" };
const _hoisted_28 = { class: "header-content" };
const _hoisted_29 = { class: "text-center" };
const _hoisted_30 = { class: "text-center" };
const _hoisted_31 = { class: "text-center item-name" };
const _hoisted_32 = { class: "text-center" };
const _hoisted_33 = { class: "text-center" };
const _hoisted_34 = { class: "text-center" };
const _hoisted_35 = { class: "text-center" };
const _hoisted_36 = { class: "text-center" };
const _hoisted_37 = { class: "text-center" };
const _hoisted_38 = { class: "text-center" };
const _hoisted_39 = { class: "text-center" };
const _hoisted_40 = ["title"];
const _hoisted_41 = { class: "text-center" };
const _hoisted_42 = { class: "text-right" };
const _hoisted_43 = { class: "text-right" };
const _hoisted_44 = { class: "text-right" };
const _hoisted_45 = { class: "text-right" };
const _hoisted_46 = { class: "text-center" };
const _hoisted_47 = { class: "header-content" };
const _hoisted_48 = { class: "text-center" };
const _hoisted_49 = { class: "text-center" };
const _hoisted_50 = { class: "text-center" };
const _hoisted_51 = { class: "text-center" };
const _hoisted_52 = { class: "text-center" };
const _hoisted_53 = { class: "text-right" };
const _hoisted_54 = { class: "text-right" };
const _hoisted_55 = { class: "text-right" };
const _hoisted_56 = { class: "text-right" };
const _hoisted_57 = { class: "text-right" };
const _hoisted_58 = { class: "text-center contents-title-text" };
const _hoisted_59 = { class: "text-center caption-normal-text mb-1" };
const _hoisted_60 = { class: "mr-1" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Chip = _resolveComponent("Chip");
    const _component_InvoicerForm = _resolveComponent("InvoicerForm");
    const _component_InvoiceeTable = _resolveComponent("InvoiceeTable");
    const _component_v_table = _resolveComponent("v-table");
    return (_ctx.taxInvoiceData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createCommentVNode(" 세금계산서 "),
                _createElementVNode("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.localeInfo.taxInvoice) + " ", 1 /* TEXT */),
                    (_ctx.taxInvoiceData.statusChipData)
                        ? (_openBlock(), _createBlock(_component_Chip, {
                            key: 0,
                            "brg-chip-color": _ctx.taxInvoiceData.statusChipData.color,
                            text: _ctx.taxInvoiceData.statusChipData.text,
                            title: _ctx.taxInvoiceData.statusFailedReason
                        }, null, 8 /* PROPS */, ["brg-chip-color", "text", "title"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" 공급자(보관용) "),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.localeInfo.billProvider), 1 /* TEXT */),
                    _createElementVNode("div", null, _toDisplayString(_ctx.localeInfo.forStorage), 1 /* TEXT */)
                ]),
                _createElementVNode("div", null, [
                    _createCommentVNode(" 책번호 "),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.localeInfo.bookNumber), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.taxInvoiceData.formattedBookNumber), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.localeInfo.bookVolume), 1 /* TEXT */)
                            ]),
                            _createElementVNode("span", _hoisted_11, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.taxInvoiceData.formattedBookIndex), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.localeInfo.bookIndex), 1 /* TEXT */)
                            ])
                        ])
                    ]),
                    _createCommentVNode(" 일련번호 "),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.localeInfo.serialNumber), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.taxInvoiceData.formattedSerialNumber), 1 /* TEXT */)
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_17, [
                _createCommentVNode(" 공급자 정보 및 Form"),
                _createVNode(_component_InvoicerForm, { lc: _ctx.lc }, null, 8 /* PROPS */, ["lc"]),
                _createCommentVNode(" 공급받는자 정보"),
                _createVNode(_component_InvoiceeTable, { lc: _ctx.lc }, null, 8 /* PROPS */, ["lc"])
            ]),
            _createVNode(_component_v_table, { class: "mb-1 content-table" }, {
                default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_18, [
                            _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.localeInfo.writeDate), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.localeInfo.supplyCost), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.localeInfo.tax), 1 /* TEXT */)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                            _createCommentVNode(" 작성일자 "),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.taxInvoiceData.formattedWriteDate), 1 /* TEXT */),
                            _createCommentVNode(" 공급가액 "),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.taxInvoiceData.formattedSupplyCost), 1 /* TEXT */),
                            _createCommentVNode(" 세액 "),
                            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.taxInvoiceData.formattedTax), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }),
            _createVNode(_component_v_table, { class: "mb-1 content-table" }, {
                default: _withCtx(() => [
                    _createElementVNode("tbody", null, [
                        _createCommentVNode(" 메모는 api에서 배열이 아니라 memo1 memo2 memo3로 인입 중 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.localeInfo.memo1), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedMemo1), 1 /* TEXT */)
                        ]),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.localeInfo.memo2), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedMemo2), 1 /* TEXT */)
                        ]),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.localeInfo.memo3), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedMemo3), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }),
            _createVNode(_component_v_table, { class: "mb-1 content-table" }, {
                default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_28, [
                            _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.localeInfo.month), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.localeInfo.day), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.localeInfo.name), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.localeInfo.spec), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.localeInfo.quantity), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.localeInfo.unitCost), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.localeInfo.supplyCost), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.localeInfo.tax), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.localeInfo.memo), 1 /* TEXT */)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxInvoiceData.taxInvoiceItemList, (item, key) => {
                            return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                _createCommentVNode(" 월 "),
                                _createElementVNode("td", _hoisted_38, _toDisplayString(item.month), 1 /* TEXT */),
                                _createCommentVNode(" 일 "),
                                _createElementVNode("td", _hoisted_39, _toDisplayString(item.date), 1 /* TEXT */),
                                _createCommentVNode(" 품목 "),
                                _createElementVNode("td", {
                                    class: "text-center item-name",
                                    title: item.name
                                }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_40),
                                _createCommentVNode(" 규격 "),
                                _createElementVNode("td", _hoisted_41, _toDisplayString(item.spec), 1 /* TEXT */),
                                _createCommentVNode(" 수량 "),
                                _createElementVNode("td", _hoisted_42, _toDisplayString(item.quantity), 1 /* TEXT */),
                                _createCommentVNode(" 단가 "),
                                _createElementVNode("td", _hoisted_43, _toDisplayString(item.unitCost), 1 /* TEXT */),
                                _createCommentVNode(" 공급가액 "),
                                _createElementVNode("td", _hoisted_44, _toDisplayString(item.supplyCost), 1 /* TEXT */),
                                _createCommentVNode(" 세액 "),
                                _createElementVNode("td", _hoisted_45, _toDisplayString(item.tax), 1 /* TEXT */),
                                _createCommentVNode(" 비고 "),
                                _createElementVNode("td", _hoisted_46, _toDisplayString(item.memo), 1 /* TEXT */)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _: 1 /* STABLE */
            }),
            _createVNode(_component_v_table, { class: "mb-1 content-table" }, {
                default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_47, [
                            _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.localeInfo.totalCost), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.localeInfo.cash), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.localeInfo.checkBill), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.localeInfo.promissoryNote), 1 /* TEXT */),
                            _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.localeInfo.credit), 1 /* TEXT */)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                            _createCommentVNode(" 합계금액 "),
                            _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.taxInvoiceData.formattedTotalCost), 1 /* TEXT */),
                            _createCommentVNode(" 현금 "),
                            _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.taxInvoiceData.formattedCash), 1 /* TEXT */),
                            _createCommentVNode(" 수표 "),
                            _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.taxInvoiceData.formattedCheckBill), 1 /* TEXT */),
                            _createCommentVNode(" 어음 "),
                            _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.taxInvoiceData.formattedPromissoryNote), 1 /* TEXT */),
                            _createCommentVNode(" 외상미수금 "),
                            _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.taxInvoiceData.formattedCredit), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }),
            _createVNode(_component_v_table, { class: "content-table mb-1" }, {
                default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.localeInfo.receiptMoneyInfoText), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }),
            _createElementVNode("p", _hoisted_59, [
                _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.localeInfo.invoicerDocumentId), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerDocumentId), 1 /* TEXT */)
            ])
        ]))
        : _createCommentVNode("v-if", true);
}
